module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/home/runner/work/slide/slide/slides.mdx",
    "dirname": "/home/runner/work/slide/slide"
  }
}];